<template>
  <div class="animated fadeIn dashboard">
  
    <b-row class="mb-5">
      <b-col cols="12" md="12" sm="12" lg="12">
        <h4 style="color:#004A7F">{{$t('dashboard.greetings')}} {{nut.first_name}} {{nut.last_name}}</h4>
        <h5 style="color:#004A7F">{{$t('dashboard.subtitle')}}</h5>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" md="6" sm="6" lg="6">
        
        <router-link to="/nutritionist/clients">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-0 clearfix">
              <b-row class="text-center">
                <b-col cols="4" sm="5" md="5" lg="4" class="justify-content-center bg-primary" >
                  <i class="fa fa-users p-2 font-2xl mr-3 icon-fa"> {{ $t('dashboard.clients') }}  {{cliCount}}</i> 
                </b-col>
                <b-col cols="8" sm="7" md="7" lg="8" style="align-items: center; display: flex;flex-direction: column;justify-content: center;">
                  <div class="h5 text-primary mb-0 mt-2">{{ $t('dashboard.last_days') }}</div>
                  <div class="text-muted text-uppercase font-weight-bold font-md"> {{ $t('dashboard.new_clients') }} : {{newClientCount}}</div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </router-link>
      </b-col>
      <b-col cols="12" md="6" sm="6" lg="6">
        <router-link to="/nutritionist/menus">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-0 clearfix">
              <b-row class="text-center">
                <b-col cols="4" sm="5" md="5" lg="4" class="justify-content-center bg-warning">
                  <i class="icon-layers p-2 font-2xl mr-3 icon-fa" > {{ $t('dashboard.menus') }}  {{menuCount}}</i> 
                </b-col>
                <b-col cols="8" sm="7" md="7" lg="8" style="align-items: center; display: flex;flex-direction: column;justify-content: center;">
                  <div class="h5 text-warning mb-0 mt-2">{{ $t('dashboard.last_days') }}</div>
                  <div class="text-muted text-uppercase font-weight-bold font-md"> {{ $t('dashboard.new_menus') }} : {{newMenuCount}}</div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </router-link>
      </b-col>
      <b-col cols="12" md="6" sm="6" lg="6">
        <router-link to="/calendar">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-0 clearfix">
              <b-row class="text-center">
                <b-col cols="4" sm="5" md="5" lg="4" class="justify-content-center bg-secondary">
                  <i class="icon-calendar p-2 font-2xl mr-3 icon-fa" > {{ $t('dashboard.meetings') }}  {{eventCount}}</i> 
                </b-col>
                <b-col cols="8" sm="7" md="7" lg="8" style="align-items: center; display: flex;flex-direction: column;justify-content: center;">
                  <div class="h5 text-secondary mb-0 mt-2">{{ $t('dashboard.last_days') }}</div>
                  <div class="text-muted text-uppercase font-weight-bold font-md"> {{ $t('dashboard.new_meetings') }} : {{newEventCount}}</div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </router-link>
      </b-col>
      <b-col cols="12" md="6" sm="6" lg="6">
        <router-link to="/orders">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-0 clearfix">
              <b-row class="text-center">
                <b-col cols="4" sm="5" md="5" lg="4" class="justify-content-center bg-success" >
                  <i class="icon-wallet p-2 font-2xl mr-3 icon-fa" > {{ $t('dashboard.sales') }}  {{salesCount}} ₪</i> 
                </b-col>
                <b-col cols="8" sm="7" md="7" lg="8" style="align-items: center; display: flex;flex-direction: column;justify-content: center;">
                  <div class="h5 text-secondary mb-0 mt-2">{{ $t('dashboard.last_days') }}</div>
                  <div class="text-muted text-uppercase font-weight-bold font-md"> {{ $t('dashboard.new_sales') }} : {{newSalesCount}} ₪</div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </router-link>
      </b-col>
    </b-row>
    
    <b-row class="mb-4">
      <b-col cols="12" md="12" sm="12" lg="12">
         <b-button type="button" size="md" variant="primary" @click="favouriteModal = true" class="pull-right"><i class="fa fa-cogs"></i></b-button>         
         <b class="pull-right" style="color:#004A7F;height: 100%;align-items: center;justify-content: center;display: flex;margin-right: 10px;"> Click here to modify your dashboard to your needs -> </b>

      </b-col>
    </b-row>
    
    
    <b-row v-if="nut.favorites == null">
      <b-col cols="6" md="6" sm="6" lg="6">
         <h5 style="color:#004A7F">{{$t('dashboard.start_by')}}</h5>
      </b-col>
      <b-col cols="3" md="3" sm="3" lg="3">
         <h5 style="color:#004A7F">{{$t('dashboard.learn_about_diets')}}</h5>
      </b-col>
    </b-row>


    <b-row>
      <b-col md="3" sm="3" lg="3"  v-for="(link,index) in selectedFavourites">
        <router-link :to="link.url">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-0 clearfix">
              <b-row class="text-center">
                <b-col sm="12" md="12" lg="12" class="justify-content-center" :style="'background-color:'+link.color">
                  <i class="icon-wallet p-2 font-2xl mr-3 icon-fa" style="color:#fff;">{{$t('nav.'+link.name)}} </i> 
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </router-link>
      </b-col>
    </b-row>

    <b-modal style="padding:1rem 6rem;" title="Please mark the box you want to have on your dashboard" size="xl" v-model="favouriteModal" @ok="addFavorite()">
      <b-row style="justify-content: center;">
        <b-col cols="12" md="3" sm="3" lg="3" v-for="(link,index) in links">
          <label style="width:100%;" :for="'myCheckbox'+index">
            <b-card :no-body="true" footer-class="px-3 py-2">
              <b-card-body class="p-0 clearfix">
                <b-row class="text-center">
                  <b-col cols="4" sm="12" md="12" lg="12" class="justify-content-center" :style="'background-color:'+link.color" >
                    <i class="icon-wallet p-2 font-2xl mr-3 icon-fa" style="color:#fff;"> {{$t('nav.'+link.name)}} </i> 
                    <input type="checkbox" :id="'myCheckbox'+index" @change="checkboxChange(index,$event)" :checked="links[index].selected" />
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            </label>
        </b-col>
      </b-row>
    </b-modal>



  </div>
</template>

<script>

// import LineExample from './charts/LineExample';
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Models from '@/store/ORM/models.js';
import Nutritionist from '@/store/ORM/nutritionists.js';
import CmsService from '@/services/cms.service.js';
import ClientService from '@/services/client.service.js';
import ProfileService from '@/services/profile.service.js';
import CreatedMenu from '@/store/ORM/created-menu.js';
// import CLientsChart from '@/components/CLientsChart';
var moment = require('moment');

export default {
  name: 'dashboard',
  components: {
    // CLientsChart,
  },
  data: function () {
    return {
      favouriteModal:false,
      selectedFavourite : ["account_settings","calendar"],
      links : [
        {
          name: 'account_settings',
          url: '/profile',
          icon: 'icon-settings',
          color: '#e6194b',
          selected:false,
        },
        {
          name: 'orders',
          url: '/orders',
          icon: 'fa fa-dollar',
          color: '#ffe119',
          selected:false,
        },
        {
          name: 'calendar',
          url: '/calendar',
          icon: 'icon-calendar',
          color: '#4363d8',
          selected:false,
        },
        {
          name: 'client_list',
          url: '/nutritionist/clients',
          icon: 'icon-people',
          color: '#911eb4',
          selected:false,
        },
        {
          name: 'send_email',
          url: '/send-email',
          icon: 'fa fa-envelope-o',
          color: '#46f0f0',
          selected:false,
        },
        {
          name: 'all_menus',
          url: '/nutritionist/menus',
          icon: 'icon-layers',          
          color: '#f032e6',
          selected:false,
        },
        {
          name: 'create_menu',
          url: '/nutritionist/create-menu',
          icon: 'icon-layers',
          color: '#bcf60c',
          selected:true,
        },
        {
          name: 'bmi',
          url: '/bmi',
          icon: 'icon-calculator',
          color: '#fabebe',
          selected:false,
        },
        {
          name: 'calculators',
          url: '/calculator',
          icon: 'icon-calculator',
          color: '#008080',
          selected:true,
        },
        {
          name: 'diets',
          url: '/diets',
          icon: 'icon-layers',
          color: '#e6beff',
          selected:true,
        },
        {
          name: 'add_client',
          url: '/nutritionist/clients/add',
          icon: 'icon-user-follow',
          color: '#f58231',
          selected:true,
        },
        {
          name: 'specialists',
          url: '/specialists',
          icon: 'icon-briefcase',
          color: '#9a6324',
          selected:false,
        },
        {
          name: 'shop',
          url: '/shop',
          icon: 'icon-basket-loaded',
          color: '#080808',
          selected:false,
        },

      ],
    }
  },
  methods: {
    getChecked(){
        this.links.map((el) => { 
          if(this.nut.favorites.indexOf(el.name) !== -1){
            el.selected = true;
          }

          return el;
        });

    },
    addFavorite(){
      this.favouriteModal = false;
      
      let selected = this.links.filter((elm)=> {return elm.selected})
      
      let body = {
        favorites: selected.map((elm) => { return elm.name;})
      };
      
      ProfileService.setFavorites(body).then(()=>{
        Models.Nutritionist.update({
          where: this.nut.id,
          data: {
            favorites: body.favorites
          }
        });
      }).catch((err)=>{
        this.$toastr("There was an error");
      });


    },
    checkboxChange(index,ev){
      this.links[index].selected = ev.target.checked;

    }
  },
  created() {
    ClientService.setAxios();
    CmsService.getBundle().then(result => {
        this.$store.dispatch(
          'CMS/UpdateRightBlocks',
          result.data.data.right_blocks
        )
        this.$store.dispatch(
          'CMS/UpdateSupplierCms',
          result.data.data.supplierscms
        )
        this.$store.dispatch(
          'CMS/UpdateLeftBlocks',
          result.data.data.left_blocks
        )
        this.$store.dispatch(
          'CMS/UpdateLandingHeader',
          result.data.data.main_page_heading[0].title
        )
        this.$store.dispatch(
          'CMS/UpdateLandingCards',
          result.data.data.main_card
        )
        this.$store.dispatch(
          'CMS/UpdateStickyHeader',
          result.data.data.header_sticky[0].title
        )

        console.log(Nutritionist.query().get());
      }).catch(err => {});

      this.nut = Nutritionist.query().first();
      this.getChecked();
  },
  
  computed: {
    newClientCount() {
      // int time interval (days) for a week it will be 7
      let now = moment(new Date())

      let count = 0

      let total = Models.Client.query().get()
      for (let i in total) {
        let ca = moment(Date.parse(total[i].created_at))
        if (now.diff(ca, 'days') <= 7) {
          count += 1
        }
      }
      return count
    },
    newMenuCount() {
      // int time interval (days) for a week it will be 7
      let now = moment(new Date())

      let count = 0

      let total = Models.Menu.query().get();

      for (let i in total) {
        let ca = moment(Date.parse(total[i].created_at))
        if (now.diff(ca, 'days') <= 7) {
          count += 1
        }
      }

      let menus = CreatedMenu.query().get();
      for (let i in menus) {
        let ca = moment(Date.parse(menus[i].created_at))
        if (now.diff(ca, 'days') <= 7) {
          count += 1
        }
      }
      return count
    },
    newEventCount() {
      // int time interval (days) for a week it will be 7
      let now = moment(new Date())

      let count = 0

      let total = Models.Event.query().get()
      for (let i in total) {
        let ca = moment(Date.parse(total[i].start))
        if (now.diff(ca, 'days') <= 7) {
          count += 1
        }
      }
      return count
    },
    newSalesCount() {
      // int time interval (days) for a week it will be 7
      let now = moment(new Date())

      let count = 0

      let total = Models.Reference.query().where('status',1).get();
      for (let i in total) {
        let ca = moment(Date.parse(total[i].created_at))
        if (now.diff(ca, 'days') <= 7) {
          count += (total[i].amount * (total[i].commission/100))
        }
      }
      return count
    },
    salesCount(){
      let count = 0
      let total = Models.Reference.query().where('status',1).get();
      for (let i in total) {
          count += (total[i].amount * (total[i].commission/100))
      }
      return count
    },
    cliCount() {
      let clients = Models.Client.query().get()
      return clients.length
    },
    menuCount() {
      let menus = Models.Menu.query().get();

      let createdMenus = CreatedMenu.query().get();
      return menus.length + createdMenus.length;
    },
    eventCount() {
      let events = Models.Event.query().get()
      return events.length
    },

    ...mapState({
      rightBlocks: state => state['CMS'].rightBlocks,
      leftBlocks: state => state['CMS'].leftBlocks,
      landingHeader: state => state['CMS'].landingHeader,
      landingCards: state => state['CMS'].landingCards
    }),
    /* istanbul ignore next */
    ...mapState([
      'route' // vuex-router-sync
    ]),

    getUser() {
      return this.$store.getters['UserModules/getUser']
    },
    msgs() {
      let msgs = Models.InternalMessage.query().get()

      return msgs
    },
    selectedFavourites(){
      let selected = [];

      console.log(this.links);
      this.links.forEach((link)=>{
        if(link.selected){
          selected.push(link);
        }
      });
      return selected;
    }
  },
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

  .icon-fa{
    height: 90px;
    align-items: center; 
    display: flex;
    flex-direction: column;
    justify-content: center;
    width:100%;
  }
  .dashboard a{
      text-decoration: none;
  }
</style>
